import { Card, CardContent, Grid, Typography } from "@mui/material";
import WidgedHeader from "./WidgedHeader";

type UpcomingDatesProps = {
  // Already filtered to upcoming, sorted nearest-first, and capped in Dashboard — this just renders.
  dates: {
    title: string;
    dateLabel: string;
    daysAway: number;
  }[];
};
const UpcomingDates = ({ dates }: UpcomingDatesProps) => {
  return (
    <Grid size={{ xs: 12, md: 4 }} sx={{ display: "flex", flexDirection: "column" }}>
      {/* No "View All": there's no upcoming-dates full-list view yet (so no viewAllHref). */}
      <WidgedHeader title="Upcoming Dates" count={dates.length} />
      <Card
        sx={{ flex: 1, minHeight: 300, border: "1px solid #e5e5e5", boxShadow: "none" }}
        className="rounded-xl"
      >
        <CardContent
          sx={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            py: "16px !important",
          }}
        >
          {dates.map((date) => {
            return (
              <div
                key={`${date.title}-${date.dateLabel}`}
                className="flex flex-row items-center gap-3 py-3"
              >
                <div
                  style={{
                    width: 8,
                    height: 8,
                    borderRadius: "50%",
                    backgroundColor: "#7e8a72",
                    flexShrink: 0,
                  }}
                />
                <div className="flex flex-row items-start justify-between flex-1">
                  <div>
                    <Typography
                      sx={{
                        fontWeight: 600,
                        fontSize: "16px",
                        lineHeight: 1,
                        color: "text.primary",
                      }}
                    >
                      {date.title}
                    </Typography>
                    <Typography
                      sx={{
                        fontWeight: 400,
                        fontSize: "14px",
                        lineHeight: "20px",
                        color: "text.secondary",
                      }}
                    >
                      {date.dateLabel}
                    </Typography>
                  </div>
                  <Typography
                    sx={{
                      fontWeight: 600,
                      fontSize: "16px",
                      lineHeight: 1,
                      color: "text.primary",
                      flexShrink: 0,
                    }}
                  >
                    {date.daysAway === 0
                      ? "Today"
                      : `${date.daysAway} Day${date.daysAway !== 1 ? "s" : ""}`}
                  </Typography>
                </div>
              </div>
            );
          })}
        </CardContent>
      </Card>
    </Grid>
  );
};

export default UpcomingDates;
